import React from 'react';
import { Zap, Mic, Brain } from 'lucide-react';

const FeatureAdoptionCard = ({ voiceUses, voiceUsers, aiUses, aiUsers, totalUsers, onVoiceClick, onAIClick }) => {
  const voiceAdoption = totalUsers > 0 ? Math.round((voiceUsers / totalUsers) * 100) : 0;
  const aiAdoption = totalUsers > 0 ? Math.round((aiUsers / totalUsers) * 100) : 0;
  
  return (
    <div className="bg-gradient-to-br from-[#2D063E] to-[#1a0527] border border-[#4A0A66]/50 rounded-xl p-4">
      <h3 className="text-sm font-semibold text-white mb-4 flex items-center gap-2">
        <Zap className="w-4 h-4 text-[#FF7901]" />
        Feature Adoption
      </h3>
      
      <div className="space-y-4">
        {/* Voice Feature */}
        <div 
          className="bg-[#4A0A66]/30 rounded-lg p-3 cursor-pointer hover:bg-[#4A0A66]/50 transition-colors border border-transparent hover:border-green-500/30"
          onClick={onVoiceClick}
          data-testid="voice-feature-card"
        >
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <Mic className="w-4 h-4 text-green-400" />
              <span className="text-sm text-white">Voice Typing</span>
            </div>
            <span className="text-xs text-[#df1283]">View users →</span>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <span className="text-xl font-bold text-green-400">{voiceUses}</span>
              <span className="text-xs text-[#FDF2F8]/50 ml-1">uses</span>
            </div>
            <div className="text-right">
              <span className="text-sm font-medium text-white">{voiceUsers}</span>
              <span className="text-xs text-[#FDF2F8]/50 ml-1">users ({voiceAdoption}%)</span>
            </div>
          </div>
        </div>
        
        {/* AI Coach */}
        <div 
          className="bg-[#4A0A66]/30 rounded-lg p-3 cursor-pointer hover:bg-[#4A0A66]/50 transition-colors border border-transparent hover:border-purple-500/30"
          onClick={onAIClick}
          data-testid="ai-feature-card"
        >
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <Brain className="w-4 h-4 text-purple-400" />
              <span className="text-sm text-white">AI Journal Coach</span>
            </div>
            <span className="text-xs text-[#df1283]">View users →</span>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <span className="text-xl font-bold text-purple-400">{aiUses}</span>
              <span className="text-xs text-[#FDF2F8]/50 ml-1">reflections</span>
            </div>
            <div className="text-right">
              <span className="text-sm font-medium text-white">{aiUsers}</span>
              <span className="text-xs text-[#FDF2F8]/50 ml-1">users ({aiAdoption}%)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureAdoptionCard;
